export const giglOpenSpaceColour = "#BFD999";
export const thamesCombinedColour = "#63c5b5";
export const thamesSeparateColour = "#943fa6";
export const watercoursesColour = "#6da7de";
export const boroughColour = "#00AEEF";
export const parkColour = "#5ea15d";
export const highwayColour = "#9e0059";
export const otherColour = "#dee000";
export const schoolColour = "#d82222";
export const socialHousingColour = "#eb861e";
export const welandColour = "#943fa6";
export const riverColour = "#6da7de";

export const opacity = 0.7;
export const highlightedOpacity = 0.8;

export const maxOffset = 0.2;
export const minOffset = -0.2;
